import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	matchesEvent,
	recordPerformedActionInCaches,
} from "web_myplann/Api/Portfolio/alertBoxesCacheUtils";
import {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
	type PortfolioEventTypeEnum,
	postPortfolioIdLeadV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type CreateLeadVariables = {
	contractId: number;
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
};

export const useCreatePortfolioLeadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, CreateLeadVariables>({
		mutationFn: processResponse(
			({ contractId, eventType, eventDate }: CreateLeadVariables) =>
				postPortfolioIdLeadV2({ eventType, eventDate }, contractId),
		),
		onSuccess: (_data, { contractId, eventType, eventDate }) => {
			recordPerformedActionInCaches(
				queryClient,
				contractId,
				matchesEvent(eventType, eventDate),
				AlertBoxActionEnum.TalkToAgent,
				AlertBoxActionStateEnum.Sent,
			);
		},
	});
};
